export const DEV = 'development'
export const PROD = 'production'
export const TEST = 'test'

export class Config {
    environment = DEV
    serverHost = '127.0.0.1'
    serverPort = '4001'
    baseURL

    get serverAddress() {
        return `${window.location.protocol}//${this.serverHost}:${this.serverPort}${this.baseURL}`
    }

    get webRoot() {
        return window.location.origin
    }

    get isProduction() {
        return this.environment === PROD
    }
}

export const config = new Config()
